import password_rejected from './password-rejected.js';
const error = {
    general_required: `{{types, list(type: disjunction;)}} là bắt buộc`,
    general_invalid: `{{types, list(type: disjunction;)}} không hợp lệ`,
    username_required: 'Tên người dùng là bắt buộc',
    password_required: 'Mật khẩu là bắt buộc',
    username_exists: 'Tên người dùng đã tồn tại',
    username_should_not_start_with_number: 'Tên người dùng không nên bắt đầu bằng số',
    username_invalid_charset: 'Tên người dùng chỉ nên chứa chữ cái, số hoặc dấu gạch dưới.',
    invalid_email: 'Email không hợp lệ',
    invalid_phone: 'Số điện thoại không hợp lệ',
    passwords_do_not_match: 'Mật khẩu của bạn không khớp. Vui lòng thử lại.',
    invalid_passcode: 'Mã xác minh không hợp lệ.',
    invalid_connector_auth: 'Ủy quyền không hợp lệ',
    invalid_connector_request: 'Dữ liệu kết nối không hợp lệ',
    unknown: 'Lỗi không xác định. Vui lòng thử lại sau.',
    invalid_session: 'Phiên không tìm thấy. Vui lòng quay lại và đăng nhập lại.',
    timeout: 'Thời gian yêu cầu đã hết. Vui lòng thử lại sau.',
    password_rejected,
    sso_not_enabled: 'Đăng nhập một lần (SSO) không được kích hoạt cho tài khoản email này.',
};
export default Object.freeze(error);
